export default "كيف\nلماذا\nكم عدد"